const doc = [({"en":({"js":({"jobler":({"job_status":({"waiting":"Waiting", "running":"Running", "error":"Error", "view_details":"View details", "completed":"Completed"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;